module.exports = __webpack_public_path__ + "img/Z6.cf7e118b.png";